import { Home, Calendar, PlusCircle, Briefcase, Handshake, Newspaper, Heart } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

export default function MenuMobile() {
    const items = [
        { name: "Feed", icon: <Home size={22} />, href: "/feed" },
        { name: "Eventos", icon: <Calendar size={22} />, href: "/eventos" },
        { name: "Publicar", icon: <PlusCircle size={22} />, href: "/publicar" },
        { name: "Vagas", icon: <Briefcase size={22} />, href: "/vagas" },
        { name: "Parceiros", icon: <Handshake size={22} />, href: "/parceiros" },
        { name: "Empregabilidade", icon: <Newspaper size={22} />, href: "/empregabilidade" },
    ];
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <nav
            className={`
                z-40
                fixed bottom-4 left-1/2 -translate-x-1/2 w-[94%] max-w-md
                bg-white/95 backdrop-blur-sm border border-gray-100 rounded-2xl shadow-lg
                flex justify-around items-center py-2
                md:hidden
            `}
        >
            <div className="flex w-full justify-around">
                {items.map((item) => (
                    <button
                        key={item.name}
                        onClick={() => navigate(item.href)}
                        className={`
                            flex flex-col items-center gap-1
                            transition-all duration-200
                            ${location.pathname === item.href 
                                ? "text-emerald-500" 
                                : "text-gray-400 hover:text-emerald-500"
                            }
                        `}
                    >
                        <div className={`
                            transition-all duration-200
                            ${location.pathname === item.href 
                                ? "scale-110" 
                                : "scale-100"
                            }
                        `}>
                            {item.icon}
                        </div>
                        <span className="text-[10px] font-medium">
                            {item.name}
                        </span>
                    </button>
                ))}
            </div>
        </nav>
    );
}